var carouselConfig = {
  theme: 'light',
  data: [],
  autoPlay: false,
  showIndicators: true,
  loop: false,
  defaultSlide: 0,
  autoPlayDelay: 0,
  autoPlayTransitionSpeed: 2000,
  slideAnimationDuration: 250,
  breakPoints: {
    xs: {
      slidesPerPage: 1,
      slidesToScroll: 1,
      itemSpacing: 8,
      seekGap: 0,
      firstSeekGapSpacing: 0,
      lastSeekGapSpacing: 0
    },
    sm: {
      slidesPerPage: 1,
      slidesToScroll: 1,
      itemSpacing: 8,
      seekGap: 0,
      firstSeekGapSpacing: 0,
      lastSeekGapSpacing: 0
    },
    md: {
      slidesPerPage: 2,
      slidesToScroll: 2,
      itemSpacing: 8,
      seekGap: 0,
      firstSeekGapSpacing: 0,
      lastSeekGapSpacing: 0
    },
    lg: {
      slidesPerPage: 3,
      slidesToScroll: 3,
      itemSpacing: 8,
      seekGap: 0,
      firstSeekGapSpacing: 0,
      lastSeekGapSpacing: 0
    },
    xl: {
      slidesPerPage: 4,
      slidesToScroll: 4,
      itemSpacing: 8,
      seekGap: 0,
      firstSeekGapSpacing: 0,
      lastSeekGapSpacing: 0
    }
  },
  onIndexChanged: () => null,
  renderItem: () => null
};
export default {
  light: carouselConfig,
  dark: carouselConfig,
  white: carouselConfig
};